export const Consts = {
    ProjectName: "LocalIQ",
    ProjectContent: "LLM Server",
    ProjectGoogleAnalytics: "G-XRFGNR341T",
    GoogleOAuthProviderClientId: "1046108424905-ujvocp8fo9rdqjhj4up39pa8l90j3ubo.apps.googleusercontent.com",
    CompanyName: "Cydanix LLC",
    ContactEmail: "support@cydanix.com",
    SiteCanonicalUrl: "https://localiq.ai",
};